import AxiosInstanceCreator from 'services/api';
import qs from 'qs';

const authInstance = new AxiosInstanceCreator().create();

export const tbmManagementApi = {
  async getList(param: any) {
    return await authInstance.get(`/tbm/page/list?${qs.stringify(param)}`).then((res) => res.data);
  },

  async getStatusCount(param: any) {
    return await authInstance
      .get(`/tbm/page/status/count?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async getDisciplineCount(param: any) {
    return await authInstance
      .get(`/tbm/page/discipline/count?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async deleteList(param: any) {
    return await authInstance.post(`/tbm/page/deleteAll`, param).then((res) => res.data);
  },

  async saveTbmStart(param: any) {
    return await authInstance.post(`/tbm/page/start`, param).then((res) => res.data);
  },

  async workStart(param: any) {
    return await authInstance.post(`/tbm/page/work/start`, param).then((res) => res.data);
  },

  async getAttendanceList(param: any) {
    return await authInstance
      .get(`/tbm/page/attendance?${qs.stringify(param)}`)
      .then((res) => res.data);
  },

  async deleteAttendance(param: any) {
    return await authInstance.post(`/tbm/page/attendance/delete`, param).then((res) => res.data);
  },

  async getPtwSelectList(param: any) {
    return await authInstance.get(`/tbm/page/ptw?${qs.stringify(param)}`).then((res) => res.data);
  },

  async saveAttendance(param: any) {
    return await authInstance.post(`/tbm/page/attendance/save`, param).then((res) => res.data);
  },

  async workComplete(param: any) {
    return await authInstance.post(`/tbm/page/work/complete`, param).then((res) => res.data);
  },

  async workResume(param: any) {
    return await authInstance.post(`/tbm/page/work/resume`, param).then((res) => res.data);
  },

  async getUserSearchList(param: any) {
    return await authInstance
      .get(`/tbm/page/userList?${qs.stringify(param)}`)
      .then((res) => res.data);
  }
};
